import { Component, OnInit } from '@angular/core';
import { isUndefined } from 'lodash';
import { ContentfulService } from '../../../../../services/contentful.service';
import { SharedService } from '../../../../shared/shared.service';
import { RegistrationSuccessComponent } from '../../../../shared/components/registration-success/registration-success.component';
import { MatDialog } from '@angular/material/dialog';
import { OnboardingService } from '../../onboarding.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-become-partner',
  templateUrl: './become-partner.component.html',
  styleUrl: './become-partner.component.less'
})
export class BecomePartnerComponent implements OnInit {

  sponsorOnboardingCMSData: any;
  locale = 'en-US';
  sponsorData: any;
  error: boolean = false;
  errorMsg: any;
  partnerAccDetails: any = {
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    communicationChannel: ''
  };

  partnerBusinessDetails: any = {
    entityType: '',
    businessName: '',
    tradingName: '',
    industry: '',
    address: '',
    addressDocument: '',
    registrationNumber: '',
    businessLogo: ''
  }

  ownerDetails: any = {
    isOwnerPartnerIdenticle: false,
    title: '',
    firstName: '',
    lastName: '',
    identificationNumber: '',
    email: '',
    phone: '',
  }

  legalDetalis: any = {
    enableTnC: false,
    enablePrivacy: false
  }

  createNewSponsorReq: any = {
    name: this.partnerBusinessDetails.businessName,
    short_name: this.partnerBusinessDetails.tradingName,
    industry: this.partnerBusinessDetails.industry,
    address: this.partnerBusinessDetails.address.formatted_address,
    trade_license_number: this.partnerBusinessDetails.registrationNumber,
    logo: this.partnerBusinessDetails.businessLogo,

    contact_person_title: this.partnerAccDetails.title,
    contact_person_first_name: this.partnerAccDetails.firstName,
    contact_person_last_name: this.partnerAccDetails.lastName,
    contact_person_name: this.partnerAccDetails.firstName + ' ' + this.partnerAccDetails.lastName,
    email: this.partnerAccDetails.email,
    phone_number: this.partnerAccDetails.phone,
    password: this.partnerAccDetails.password,
    confirmpassword: this.partnerAccDetails.confirmPassword,

    extra_data: {
      entity_type: this.partnerBusinessDetails.entityType,
      Preferred_Comms: this.partnerAccDetails.communicationChannel,
      title: this.ownerDetails.title,
      owner_email: this.ownerDetails.email,
      owner_first_name: this.ownerDetails.firstName,
      owner_last_name: this.ownerDetails.lastName,
      national_id: this.ownerDetails.identificationNumber,
      "owner's_phone_number": this.ownerDetails.phone,
      tnc_checkbox: this.legalDetalis.enableTnC ? 'YES' : 'NO',
      privacy_policy_checkbox: this.legalDetalis.enablePrivacy ? 'YES' : 'NO',
    }
  }
  getGenericLabels: any;

  constructor(
    private contentfulService: ContentfulService,
    private sharedService: SharedService,
    private matDialog: MatDialog,
    private onboardingService: OnboardingService,
    private router: Router,
  ) {}
  
  ngOnInit(): void {
    this.getLandingCMSData();
    this.getGenericLabels = JSON.parse(localStorage.getItem('genericLabels') || '{}');
  }

  cancel() {
    this.router.navigate(['/home']);
  }

  submitDetails() {
    this.sharedService.toggleGlobalLoader(true);
    var createSponsorReq = {
      name: this.partnerBusinessDetails.businessName,
      short_name: this.partnerBusinessDetails.tradingName,
      industry: this.partnerBusinessDetails.industry,
      address: this.partnerBusinessDetails.address,
      trade_license_number: this.partnerBusinessDetails.registrationNumber,
      logo: this.partnerBusinessDetails.businessLogo,
  
      contact_person_title: this.partnerAccDetails.title,
      contact_person_first_name: this.partnerAccDetails.firstName,
      contact_person_last_name: this.partnerAccDetails.lastName,
      contact_person_name: this.partnerAccDetails.firstName + ' ' + this.partnerAccDetails.lastName,
      email: this.partnerAccDetails.email,
      phone_number: this.partnerAccDetails.phone,
      password: this.partnerAccDetails.password,
      confirmpassword: this.partnerAccDetails.confirmPassword,
      username: this.partnerAccDetails.email,
  
      extra_data: {
        entity_type: this.partnerBusinessDetails.entityType,
        Preferred_Comms: this.partnerAccDetails.communicationChannel,
        title: this.ownerDetails.title,
        owner_email: this.ownerDetails.email,
        owner_first_name: this.ownerDetails.firstName,
        owner_last_name: this.ownerDetails.lastName,
        national_id: this.ownerDetails.identificationNumber,
        "owner's_phone_number": this.ownerDetails.phone,
        tnc_checkbox: this.legalDetalis.enableTnC ? 'YES' : 'NO',
        privacy_policy_checkbox: this.legalDetalis.enablePrivacy ? 'YES' : 'NO',
        sponsor_pin_threshold: 10
      }
    }

    this.onboardingService.createNewSponsor(createSponsorReq).subscribe({
        next: (data: any) => {
          this.matDialog.open(RegistrationSuccessComponent,{
            backdropClass: 'backdropBackground',
            panelClass: 'custom-dialog-container',
            width: '680px',
            disableClose: true,
          });
          this.sharedService.toggleGlobalLoader(false);
        },
        error: (error: any) => {
          this.error = true;
          this.errorMsg = error.error;
          this.sharedService.toggleGlobalLoader(false);
        },
    });
  }

  partnerAccountDataValueChange(event: any) {
    this.partnerAccDetails = event;
  }

  partnerBusinessDataValueChange(event: any) {
    this.partnerBusinessDetails = event;
  }

  ownerDataValueChange(event: any) {
    this.ownerDetails = event;
  }

  legalDataValueChange(event: any) {
    this.legalDetalis = event;
  }
  get isValid() {
    const nonMandatoryAttributes = ['businessLogo', 'addressDocument'];
    if(this.partnerBusinessDetails.entityType === 'SOLE PROP') {
      nonMandatoryAttributes.push('registrationNumber');
    }

    let isButtonDisabled = true;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const password = this.partnerAccDetails['password'];
    const confirmPassword = this.partnerAccDetails['confirmPassword'];

    for(let obj in this.partnerAccDetails){
      const value = this.partnerAccDetails[obj];
      if(this.partnerAccDetails[obj] === null || this.partnerAccDetails[obj] === undefined || this.partnerAccDetails[obj] === '') {
        isButtonDisabled = true; // Disable the button if any mandatory field is invalid
        return isButtonDisabled;
      }
      if (obj === 'email' && !emailPattern.test(value)) {
        isButtonDisabled = true; // Disable the button if email is invalid
        return isButtonDisabled;
      }
      if (password !== confirmPassword) {
        isButtonDisabled = true; // Disable if they don't match
        return isButtonDisabled;
      }
    }

    for (let obj in this.partnerBusinessDetails) {
      if (nonMandatoryAttributes.includes(obj)) {
        continue;
      }
      if (this.partnerBusinessDetails[obj] === null || this.partnerBusinessDetails[obj] === undefined || this.partnerBusinessDetails[obj] === '') {
        return true;
      }
    }

    for(let obj in this.ownerDetails){
      if(this.ownerDetails[obj] === null || this.ownerDetails[obj] === undefined || this.ownerDetails[obj] === '') {
        return true;
      }
    }

    for(let obj in this.legalDetalis){
      if(this.legalDetalis[obj] === false || this.legalDetalis[obj] === undefined || this.legalDetalis[obj] === '') {
        return true;
      }
    }
    return false;
  }

  getLandingCMSData() {
    this.sharedService.toggleGlobalLoader(true);
    this.contentfulService.getContent("35bdbvzhHRi3guRfwrXFmi", this.locale).subscribe(
      (data:any) => {
        this.sponsorOnboardingCMSData = data;
        this.sharedService.toggleGlobalLoader(false);
      }
    );
  }

}
